import React, { useState } from "react";
import {
  useDeleteContactUsMutation,
  useGetAllMessagesQuery,
  useMarkAllAsReadMutation,
} from "../../redux/contactApi";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { ReactSVG } from "react-svg";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import { truncateText } from "../Media/Media";
import ButtonLoading from "../Button loading/ButtonLoading";
import { useDebounce } from "use-debounce";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

dayjs.extend(relativeTime);

const ContactUs = () => {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [debouncedSearch] = useDebounce(search, 1500);

  const handlePrev = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const handleNext = () => {
    if (page < data?.totalPages) setPage((prev) => prev + 1);
  };

  const { data, error, isLoading, isFetching } = useGetAllMessagesQuery({
    page,
    search: debouncedSearch,
  });
  const [deleteContactUs, { isLoading: isDeleteLoading }] =
    useDeleteContactUsMutation();
  const [markAllAsRead, { isLoading: isMarkedAllLoading }] =
    useMarkAllAsReadMutation();
  const [deletingId, setDeletingId] = useState(null);

  const handleDelete = async (id) => {
    setDeletingId(id);
    try {
      const response = await deleteContactUs(id).unwrap();
      if (response.success) {
        toast.success(response.message);
      }
    } catch (err) {
      console.error("contact us error:", err);
      toast.error(err.data.messaage);
    } finally {
      setDeletingId(null);
    }
  };

  const handleMarkAllAsRead = async () => {
    try {
      const response = await markAllAsRead().unwrap();
      if (response.success) {
        toast.success(response.message);
      }
    } catch (err) {
      console.error("contact us error:", err);
      toast.error(err.data.messaage);
    }
  };

  const loading = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  return (
    <div className=" flex flex-col lg:gap-10 md:gap-6 gap-4 bg-white rounded-xl xl:p-8 lg:p-6 p-4">
      <div className="flex justify-between items-center">
        <p className="text-[#05004E] font-semibold lg:text-[1.8rem] md:text-[1.4rem] text-[1.2rem]">
          Messages
        </p>

        <button
          disabled={isMarkedAllLoading}
          onClick={() => {
            handleMarkAllAsRead();
          }}
          className="lg:w-[12rem] md:w-[10rem] w-max bg-[#00643b] text-center flex justify-center items-center lg:py-3 md:py-2 md:px-0 px-2 py-1.5 lg:text-[1rem] md:text-[.9rem] text-[.75rem] md:rounded-xl rounded-lg font-medium text-white disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isMarkedAllLoading ? (
            <ButtonLoading text="Marked All..." />
          ) : (
            "Mark All as Read"
          )}
        </button>
      </div>
      <div className=" flex flex-col gap-4 w-full">
        <div className=" flex justify-end w-full">
          <input
            type="search"
            placeholder="Search by name, email, or subject..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setPage(1);
            }}
            className="border-2 rounded-xl border-[#05004e40] md:p-3 p-2 outline-none md:w-[24rem] md:text-[1rem] text-[.8rem] w-[18rem]"
          />
        </div>
        {isLoading || isFetching ? (
          <div className=" grid lg:grid-cols-2 grid-cols-1 gap-3 ">
            {loading.map((i) => (
              <div
                key={i}
                className="bg-[#EFEFEF] animate-pulse p-3 rounded-xl flex flex-col gap-1.5"
              >
                <p className=" bg-[#97979750] h-5 rounded-lg animate-pulse w-[90%]"></p>
                <p className=" bg-[#97979750] h-4 rounded-lg animate-pulse w-[70%]"></p>
                <p className=" bg-[#97979750] h-4 rounded-lg animate-pulse w-[50%]"></p>
              </div>
            ))}
          </div>
        ) : (
          data && (
            <>
              {data?.totalPages === 0 ? (
                <div className=" text-center w-full lg:text-[3rem] md:text-[2rem] text-[1.4rem] font-semibold text-[#05004E]">
                  No Message Found
                </div>
              ) : (
                <div className="grid lg:grid-cols-2 grid-cols-1 gap-4 ">
                  {data?.messages?.map((message) => (
                    <div
                      key={message?._id}
                      className={`bg-[#DEE9E4] rounded-xl flex flex-col md:gap-2 gap-[6px] md:p-3 p-2 ${
                        message?.markAsRead ? "opacity-50" : "opacity-100"
                      }`}
                    >
                      <div className=" flex justify-between items-center gap-2">
                        <h1 className="lg:text-[1.3rem] md:text-[1.2rem] text-[1rem] capitalize text-[#00643B] md:font-bold font-semibold">
                          {truncateText(message?.subject, 25)}
                        </h1>
                        <p className=" text-[#827D7D] sm:text-[12px] text-[10px]">
                          {dayjs(message?.createdAt).fromNow()}
                        </p>
                      </div>

                      <div className=" flex justify-between items-end gap-2">
                        <div>
                          <p className="text-[#00643b] md:text-[1.1rem] text-[.8rem] font-medium capitalize">
                            {message?.name}
                          </p>
                          <p className=" font-medium md:text-[1rem] text-[.75rem] ">
                            {message?.email}
                          </p>
                        </div>
                        <div className=" flex items-center gap-[6px] text-white">
                          <NavLink
                            to={`/contact-us/${message?._id}`}
                            className="md:h-9 md:w-9 h-7 w-7 flex justify-center items-center rounded-lg bg-[#00643B]"
                          >
                            <ReactSVG
                              src={`/icon/view.svg`}
                              className={`md:w-6 w-4`}
                            />
                          </NavLink>
                          <button
                            onClick={() => handleDelete(message?._id)}
                            disabled={
                              isDeleteLoading && deletingId === message._id
                            }
                            className="md:h-9 md:w-9 h-7 w-7 flex justify-center items-center rounded-lg bg-[#B22234] disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            {isDeleteLoading && deletingId === message._id ? (
                              <ButtonLoading />
                            ) : (
                              <ReactSVG
                                src={`/icon/delete.svg`}
                                className={`md:w-5 w-3`}
                              />
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <div className=" flex justify-between items-center">
                <div className=" text-[#0000004f]">
                  Showing record page {data?.currentPage} 0f {data?.totalPages}
                </div>
                <div className=" flex items-center gap-4">
                  <div
                    onClick={handlePrev}
                    disabled={page === 1}
                    className={`bg-[#02643B1F] p-2 text-[#00643b] rounded-xl ${
                      page === 1
                        ? " cursor-not-allowed opacity-50"
                        : "cursor-pointer"
                    }`}
                  >
                    <IoIosArrowBack className="size-6" />
                  </div>
                  {data?.currentPage}
                  <div
                    onClick={handleNext}
                    disabled={page === data?.totalPages}
                    className={`bg-[#02643B1F] p-2 text-[#00643b] rounded-xl ${
                      page === data?.totalPages
                        ? " cursor-not-allowed opacity-50"
                        : "cursor-pointer"
                    }`}
                  >
                    <IoIosArrowForward className="size-6" />
                  </div>
                </div>
              </div>
            </>
          )
        )}{" "}
      </div>
      {error && <p>{error.message}</p>}
    </div>
  );
};

export default ContactUs;
